<template>
  <div >
    <div class="d-flex flex-column" style="height:100%;background:#f7f7f7" id="page2">
      <v-header></v-header>

    	<div class="content">
        <template v-for="(item,index) in list">
          <div class="items">
            <div v-on:click="toDetail(item.id)">
              <div class="itemImg">
                <img :src="item.src" class="itemImg"/>
              </div>
              <div class="titlePad twoLine" style="height: 32px;">{{item.text}}</div>
              <div class="d-flex align-items-center justify-content-between" style="padding:0 15px 20px 15px;height: 52px;">
                <div class="d-flex align-items-center">
                  <img :src="item.headUrl" style="width:30px;height:30px;border-radius:50%;margin-right:6px"/>
                  <div class="twoLine" >{{item.nickname}}</div>
                </div>

                <div class="d-flex align-items-center">
                  <img src="../../assets/img/index/like.png" style="width:15px;height:15px;margin-right:10px" />
                  <div>{{item.likeNum}}</div>
                </div>
              </div>
            </div>
          </div>
        </template>
    	</div>
      <div style="font-size:18px;color:#ff9a2e;font-weight: bolder;text-align: center;padding:20px 0 55px 0;cursor: pointer;" v-on:click="lookMore(layerShow)">查看更多</div>
      <v-footer></v-footer>
    </div>
    <div style="width:100%;height:100%;position: fixed;top:0;left:0;z-index:10;background:rgba(0,0,0,0.5)" v-if="layerShow" class="d-flex flex-column align-items-center justify-content-center">
      <div style="width:210px;background:#fff" class="d-flex align-items-center justify-content-center flex-column pad-left5 pad-right5 pad-top10 pad-bottom10">
        <img src="../../assets/img/index/miniProjectImg.jpg" style="width:200px;height:200px;" />
        <div class="fz14 c-333333 mar-top5">请扫码前往小程序操作</div>
        <div class="c-999999 mar-top10" style="font-size:10px">兴趣百科-再小的兴趣也是同好</div>
      </div>
      <img src="../../assets/img/index/close.png" style="width:25px;height:25px;margin-top:25px" v-on:click="lookMore(layerShow)"/>
    </div>
  </div>

</template>

<script>
import axios from "axios";
import header from '@/pages/pc/header';
import footer from '@/pages/pc/footer';
export default {
  name: 'pcIndex',
  components:{
    'v-header':header,
    'v-footer':footer
  },
  data () {
    return {
      list: [],//日记列表
      layerShow:false
    }
  },
  mounted(){//页面加载后，调用接口数据
    this.getData();

  },
  methods:{
    lookMore:function(param){//点击查看更多方法
      this.layerShow=!param
    },

    toDetail:function(id){//点击日记跳转到详情页
    console.log("日记id是："+id)
      this.$router.push({ name: 'pcDiaryDetail',params:{id:id,name:'yx'}})
    },

    //获取数据列表
    getData:function(){
      var data = {}
      axios.post('https://www.xingqubaike.com/wx/handshake-provider-xswl-home/home/official/getDiaryList',data).then(response => {
          this.list=response.data.result.list
      }, response => {
          console.log("error");
      });
    }


  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="less">
  @import "../../../static/css/firstPage.css"; //直接在需要对应的vue中使用es6进行引入
  .titlePad{padding:0 20px;margin:15px 0}
  .content{position: relative;}
  #header{background:#FFFFFF}
  #header a{color:#333333}
  #footer a{color:#666}
  #page2 #diaryList{color:#fe7f0c;border-bottom:3px solid #fe7f0c;}
  .vativalLine{height:40px;width:5px;border-radius: 5px;margin-top:5px}
  .bgc-c97b28{background:#c97b28}
  .c-c97b28{color:#c97b28}

  @media only screen and (min-width:768px) and (max-width:1279px){
    .itemImg{width:100%;height: 18vw;object-fit: cover;}
    .bigImg{width: 98%;height: 14vw;margin-bottom: 1%;position: relative;background-size: cover;background-repeat: no-repeat;}
    .content{width: 50%;margin:30px auto}
    .title{margin: 0 30px;font-size: 26px;color: #f7f7f7;}
    .userInfo{margin-left: 20px;line-height: 3vw;position: absolute;bottom: 1vw; left: 0;}
    .username{float: left;margin-left: 8px;font-size: 20px;color: #f7f7f7;}
    .items{border:1px solid #e8e8e8;margin:0 auto 20px;height:auto;overflow:auto;width:48%;border-radius:8px;float: left;margin-right: 1%;}
  }
  @media only screen and (min-width:1279px){
    .itemImg{width:100%;height: 18vw;object-fit: cover;}
    .bigImg{width: 98%;height: 14vw;margin-bottom: 1%;position: relative;background-size: cover;background-repeat: no-repeat;}
    .content{width: 50%;margin:30px auto}
    .title{margin: 0 30px;font-size: 30px;color: #f7f7f7;}
    .userInfo{margin-left: 30px;line-height: 3vw;position: absolute;bottom: 1vw; left: 0;}
    .username{float: left;margin-left: 10px;font-size: 24px;color: #f7f7f7;}
    .items{border:1px solid #e8e8e8;margin:0 auto 20px;height:auto;overflow:auto;width:31%;border-radius:8px;float: left;margin-right: 2%;}
  }
  @media screen and (max-device-width:767px){
    .itemImg{width:100%;height: 25vw;object-fit: cover;}
    .bigImg{width: 98%;height: 30vw;margin-bottom: 1%;position: relative;background-size: cover;background-repeat: no-repeat;}
    .content{width: 96%;margin:30px auto}
    .title{margin: 0 30px;font-size: 26px;color: #f7f7f7;}
    .userInfo{margin-left: 20px;line-height: 3vw;position: absolute;bottom: 3vw; left: 0;}
    .username{float: left;margin-left: 8px;font-size: 20px;color: #f7f7f7;}
    .items{border:1px solid #e8e8e8;margin:0 auto 20px;height:auto;overflow:auto;width:48%;border-radius:8px;float: left;margin-right: 1%;}
  }

  @media screen and (max-width:767px){
    .itemImg{width:100%;height: 25vw;object-fit: cover;}
    .bigImg{width: 98%;height: 30vw;margin-bottom: 1%;position: relative;background-size: cover;background-repeat: no-repeat;}
    .content{width: 96%;margin:30px auto}
    .title{margin: 0 30px;font-size: 26px;color: #f7f7f7;}
    .userInfo{margin-left: 20px;line-height: 3vw;position: absolute;bottom: 3vw; left: 0;}
    .username{float: left;margin-left: 8px;font-size: 20px;color: #f7f7f7;}
    .items{border:1px solid #e8e8e8;margin:0 auto 20px;height:auto;overflow:auto;width:48%;border-radius:8px;float: left;margin-right: 1%;}
  }
  
</style>



// WEBPACK FOOTER //
// src/pages/pc/diaryList.vue